import type { AutomationCategoryResponse } from '@reach/shared-types/automation-category';
import { CategoryPill } from '../CategoryPill/CategoryPill';
import styles from './CategoryPillList.module.css';

const VISIBLE_CATEGORY_COUNT = 2;

interface CategoryPillListProps {
  categories: AutomationCategoryResponse[];
}

/** The first few categories as pills, with the rest summarized as "+N". Used in the templates list. */
export function CategoryPillList({ categories }: CategoryPillListProps) {
  if (categories.length === 0) return null;

  const visibleCategories = categories.slice(0, VISIBLE_CATEGORY_COUNT);
  const hiddenCategories = categories.slice(VISIBLE_CATEGORY_COUNT);
  const hiddenCategoryNames = hiddenCategories.map(category => category.name).join(', ');
  const overflowText = `+${hiddenCategories.length}`;

  return (
    <ul className={styles.categoryPillList} aria-label="Categories">
      {visibleCategories.map(category => (
        <li key={category.id}>
          <CategoryPill category={category} />
        </li>
      ))}
      {hiddenCategories.length > 0 && (
        <li className={styles.overflowCount} title={hiddenCategoryNames}>
          {overflowText}
        </li>
      )}
    </ul>
  );
}
